import React from 'react';
import PropTypes from 'prop-types';
import { dig } from 'spiceutils';

/**
 * Simple input field that takes a number and then updates the CDF accordingly.
 * Updates either NoSampleThreshold or LowSampleThreshold depending on what type
 * is passed in as a prop.
 */
class SampleThreshold extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: getValueFromProps(props) || '' };

    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(e) {
    this.state.value = getValueFromProps(e);
    this.setState(this.state);
  }

  onChange(e) {
    this.state.value = e.target.value;
    this.setState(this.state);

    // Send the update to the appropriate CDF field
    this.props.updateCDF(this.props.type, e.target.value);
  }

  render() {
    // Validate that type was passed in correctly
    if (!this.props.type) throw new Error('SampleThreshold component requires a type');
    if (!['LowSampleThreshold', 'NoSampleThreshold'].includes(this.props.type)) {
      throw new Error('SampleThreshold type must be either NoSampleThreshold or LowSampleThreshold');
    }

    const friendlyName = this.props.type.replace(/([A-Z])/g, ' $1');
    if (dig(this.props.controlList, [this.props.type, 'Visible']) === true) {
      return (
        <div>
          <label htmlFor={this.props.name}>{friendlyName}</label>
          <input type="number" value={this.state.value} name={this.props.name} onChange={(e) => this.onChange(e)} />
        </div>
      );
    }

    return null;
  }
}

const getValueFromProps = (props) => props.cdf[props.type] || '';

SampleThreshold.propTypes = {
  // Function that updates the CDF
  updateCDF: PropTypes.func.isRequired,
  // CDF that includes the object that this select refers to.
  // eslint-disable-next-line
  cdf: PropTypes.object.isRequired,
  // Name given to the input field
  name: PropTypes.string,
  // Type of SampleThreshold. Required and validated. Used for generating label
  // and passing values onto the CDF.
  type: PropTypes.oneOf(['LowSampleThreshold', 'NoSampleThreshold']).isRequired,
  // Used to determine if the component should be rendered or not
  controlList: PropTypes.object,
};

export default SampleThreshold;



// WEBPACK FOOTER //
// ./app/components/FormControls/SampleThreshold/index.js